import {
  mapGetters
} from "vuex";
export default {
  data() {
    return {
      activity: {
        newCompany: "Създаване на проект",
        editCompany: "Редактиране на проект",
        newUser: "Създаване на потребител",
        editUser: "Редактиране на потребител",
        newReport: "Създаване на отчет",
        editReport: "Редактиране на отчет",
        newCalendar: "Създаване на заявка",
        deleteCalendar: "Изтриване на заявка",
        confirmCalendar: "Потвърждаване на заявка",
        readyCalendar: "Изпращане на заявка за потвърждаване"
      }
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser"
      // ...
    ])
  },
  methods: {
    newLog(activity, additional) {
      const info = additional || '';
      if (this.activity[activity]) {
        let url = `${process.env.VUE_APP_BASE_URI}/log`;
        let log = {
          activity: `${this.activity[activity]} - ${info}`,
          createdBy: this.getUser._id
        }
        this.$http
          .post(url, log)
          .then(a => {
            if (a.data.errors) {
              console.log(a.data.errors)
            }
          })
          .catch(error => {
            console.log(error.response);
          });
      }
    }
  }
}